module.exports = __webpack_public_path__ + "static/media/icon_nav_store.d30b599f.svg";